import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/jelly.css'
import moment from 'moment-timezone'

import Spinner from './sitewide/Spinner'
import Dashboard from './Dashboard'
import Messages from './Messages'
import CallLog from './CallLog'
import Patients from './PatientGroups/'
import PatientPage from './PatientPage'
import Schedule from './Schedule'
import Settings from './Settings'
import Account from './Account'
import OnlineScheduling from './OnlineScheduling'
import EditorAuditor from './sitewide/RichTextEditor/Auditor'
import LeftMenu from './LeftMenu'
import TopMenu from './TopMenu'
import Socket from './Socket'
import { fetchCurrentUser, setPreviousUrl } from '../state/actions/account'
import './App.css'

const styles = {
  toolbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'white',
    boxShadow: '0px 2px 5px #d6d6d6',
    zIndex: 5,
  },
  iconContainer: {
    position: 'relative',
    paddingLeft: '20px',
    paddingRight: '20px',
    borderLeft: '1px solid #777777',
  },
  icon: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '25px',
    height: '100%',
    cursor: 'pointer',
  },
  iconFill: '#777777',
  iconActive: '#fff',
}

class App extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      hasNewPatientOS: PropTypes.bool.isRequired,
      hasReminders: PropTypes.bool.isRequired,
    }).isRequired,
    fetchUser: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    setPreviousUrl: PropTypes.func.isRequired,
    user: PropTypes.shape({
      username: PropTypes.string,
      timezone: PropTypes.string,
    }).isRequired,
  }

  static defaultProps = {
    user: {
      username: '',
      timezone: null,
    },
  }

  state = {} // keep b/c calendar icon looks here...

  componentWillMount() {
    if (!this.props.user.username) {
      this.props.fetchUser()
    }
  }

  // sets global timezone for all moment objects
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.user.timezone !== this.props.user.timezone &&
      nextProps.user.timezone
    ) {
      moment.tz.setDefault(nextProps.user.timezone)
    }
  }

  render() {
    const {
      auth: {
        hasDSO,
        hasNewPatientOS,
        hasReminders,
        hasReviews,
        hasScreenPop,
        hasTopsRemindersPlus,
        isFetching,
      },
      user: { username, callerIdEnabled, locations: userLocations },
      location,
      setPreviousUrl,
    } = this.props

    if (isFetching) {
      return <Spinner />
    }
    if (!username) {
      setPreviousUrl(`${location.pathname}${location.search}`)
      return <Redirect to="/login" />
    }
    const showTopMenu = hasDSO && userLocations && userLocations.length > 1
    return (
      <div>
        <LeftMenu location={location} />
        <div className="App" style={styles.pageContainer}>
          {showTopMenu && <TopMenu />}
          <Switch>
            <Route path="/messages" component={Messages} />
            <Route
              path="/calls"
              render={props =>
                hasScreenPop ? <CallLog {...props} /> : <Redirect to="/" />
              }
            />
            <Route exact path="/patients/:id" component={PatientPage} />
            <Route path="/schedule" component={Schedule} />
            <Route path="/settings" component={Settings} />
            <Route path="/account" component={Account} />
            <Route path="/editor" component={EditorAuditor} />
            <Route
              path="/patients"
              render={props =>
                hasReminders || hasScreenPop ? (
                  <Patients {...props} />
                ) : (
                  <Redirect to="/openchair" />
                )
              }
            />
            <Route
              path="/openchair"
              render={props =>
                hasNewPatientOS ? (
                  <OnlineScheduling {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
            <Route
              path="/"
              render={props =>
                hasReminders || hasReviews || hasTopsRemindersPlus ? (
                  <Dashboard {...props} />
                ) : hasNewPatientOS ? (
                  <Redirect to="/openchair" />
                ) : (
                  <Redirect to="/account" />
                )
              }
            />
          </Switch>
        </div>
        <Alert stack={{ limit: 3 }} />
        <Socket
          channelName="PracticeChannel"
          callerIdEnabled={callerIdEnabled}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ account }) => ({
  auth: account.auth,
  user: account.user,
})

const mapDispatchToProps = dispatch => ({
  fetchUser: () => dispatch(fetchCurrentUser),
  setPreviousUrl: previous => dispatch(setPreviousUrl(previous)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js